<template>
  <div class="container">
    <div class="floatContact" @click="openFormMoadl">
      <img src="../assets/images/kf_1.png" />
    </div>
    <div class="topMenu">
      <!-- <img class="logo" src="../assets/images/logo.png" /> -->
      <span style="font-size: 0.2rem;">涿溪防窜货</span>
      <!-- <template v-if="menuState === 'dafault'">
        <img class="menu_icon" src="../assets/images/menu.png" @click="openMenu" />
      </template>
      <template v-else-if="menuState === 'open'">
        <img class="menu_icon" src="../assets/images/close.png" @click="closeMenu" />
      </template> -->
    </div>
    <div class="subMenu" :class="[aniClass]" :style="{height: h+'rem'}">
      <ul>
        <li>产品介绍<img src="../assets/images/arrow_right.png" /></li>
        <li>解决方案<img src="../assets/images/arrow_right.png" /></li>
        <li>行业趋势<img src="../assets/images/arrow_right.png" /></li>
        <li>客户案例<img src="../assets/images/arrow_right.png" /></li>
        <li>认识我们<img src="../assets/images/arrow_right.png" /></li>
      </ul>
    </div>
    <div class="homeWrap">
      <img src="../assets/images/home.png" />
      <div class="title">开源节流 就选涿溪防窜货</div>
      <div class="content">一站式全流程防伪营销，数据管理全面实现开源节流。涿溪防窜货，定义新的营销方式。</div>
      <div class="btns">
        <span class="my_btn" @click="openFormMoadl">立即体验</span>
      </div>
    </div>
    <div class="whatWrap">
      <div class="title">涿溪防窜货是什么？</div>
      <div class="content">
        涿溪防窜货是日化行业的数字身份证，基于国家工信部建立的标识解析体系，可以为企业提供国家标识认证、专利防伪、一物一码、裂变复购等一站式服务。
      </div>
      <!-- <video-player class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
      ></video-player> -->
      <!-- https://mzmpic.oss-cn-beijing.aliyuncs.com/mzmvideo.mp4 -->
      <video style="width: 100%;" src="https://mzmpic.oss-cn-beijing.aliyuncs.com/rihumaVideo.mp4" controls="controls"></video>
    </div>
    <div class="placeWrap">
      <div class="title">涿溪防窜货适用场景</div>
      <div class="content">全国5000家日化企业适用场景</div>
      <div class="placeList">

        <div class="placeItem">
          <img src="../assets/images/fwfc.png" />
          <div class="place_info">
            <div class="tit">防伪防窜</div>
            <div class="text">国家标识防伪防窜，有据可查</div>
          </div>
        </div>

        <div class="placeItem">
          <img src="../assets/images/ywym.png" />
          <div class="place_info">
            <div class="tit">一物一码</div>
            <div class="text">基于国家标识，一物赋一码</div>
          </div>
        </div>

        <div class="placeItem">
          <img src="../assets/images/ppyx.png" />
          <div class="place_info">
            <div class="tit">品牌营销</div>
            <div class="text">为品牌正名，提升品牌影响力</div>
          </div>
        </div>

        <div class="placeItem">
          <img src="../assets/images/lbfg.png" />
          <div class="place_info">
            <div class="tit">裂变复购</div>
            <div class="text">防伪码集成，H5链接商城复购</div>
          </div>
        </div>

         <div class="placeItem">
          <img src="../assets/images/dsj.png" />
          <div class="place_info">
            <div class="tit">大数据管理</div>
            <div class="text">BOSS端实时查看，用户扫码数据</div>
          </div>
        </div>


      </div>
    </div>
    <div class="guideWrap">
      <div class="title">引领新的营销方式</div>

      <div class="guideBlock">
        <div class="guideTop">
          <span>链接国家标识</span>
          <span class="link" @click="openFormMoadl">了解国家标识 > </span>
        </div>
        <div class="guideText">
          涿溪防窜货对接工业互联网标识解析，通过使用涿溪防窜货，链接国家标识，强化企业、产品背书，让用户对企业放心，产品用的安心。
        </div>
        <div>
          <img class="guide_img" src="../assets/images/gj_t.png" />
        </div>
      </div>

      <div class="guideBlock grey">
        <div class="guideTop">
          <span>让专利防伪更官方</span>
          <span class="link" @click="openFormMoadl">了解国家标识 > </span>
        </div>
        <div class="guideText">
          涿溪防窜货防伪技术经过专利认证，同时对接国家标识，由国家工信部授权，每一个防伪码都是全球唯一，让产品造假商、防伪码造假商无所遁形。
        </div>
        <div>
          <img class="guide_img" src="../assets/images/zl_t.png" />
        </div>
      </div>

      <div class="guideBlock">
        <div class="guideTop">
          <span>让裂变复购更简单</span>
          <span class="link" @click="openFormMoadl">了解裂变复购 > </span>
        </div>
        <div class="guideText">
          通过涿溪防窜货营销复购功能，用户复购过程中，全程绑定在码内，无需担心用户流失在其他渠道，同时由此裂变的用户也会与产品涿溪防窜货绑定，裂变复购简单安全、路径统一。
        </div>
        <div>
          <img class="guide_img" src="../assets/images/lb_t.png" />
        </div>
      </div>
    </div>
    <div class="improveWrap change">
      <div class="title">涿溪防窜货全力提升企业开源 节流能力</div>
      <img class="ywym_img" src="../assets/images/lx_t.png" />
      <div class="ywym_tit">一物一码，让产品流向有据可查</div>
      <img class="sj_img" src="../assets/images/sj_t.png" />
      <div class="sj_tit">让数据更可视化，实现产品的全生命周期管理</div>
    </div>
    <div class="caseWrap">
      <div class="title">他们都在用涿溪防窜货</div>
      <div>
        <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item>
            <div class="caseItem">
              <img class="case_pro" src="../assets/images/case_pro1.png" />
              <div class="case_msg">涿溪防窜货是一款一站式全流程防伪营销，数据管理全面实现开源节流。<br />涿溪防窜货，定义新的营销方式。</div>
              <div class="case_info">
                <img src="../assets/images/case_logo1.png" />
                <div class="case_from">
                  <div class="name">XX</div>
                  <div class="job">潞安娜销售总监</div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="caseItem">
              <img class="case_pro" src="../assets/images/case_pro1.png" />
              <div class="case_msg">涿溪防窜货是一款一站式全流程防伪营销，数据管理全面实现开源节流。<br />涿溪防窜货，定义新的营销方式。</div>
              <div class="case_info">
                <img src="../assets/images/case_logo1.png" />
                <div class="case_from">
                  <div class="name">XX</div>
                  <div class="job">潞安娜销售总监</div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="caseItem">
              <img class="case_pro" src="../assets/images/case_pro1.png" />
              <div class="case_msg">涿溪防窜货是一款一站式全流程防伪营销，数据管理全面实现开源节流。<br />涿溪防窜货，定义新的营销方式。</div>
              <div class="case_info">
                <img src="../assets/images/case_logo1.png" />
                <div class="case_from">
                  <div class="name">XX</div>
                  <div class="job">潞安娜销售总监</div>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe> -->
        <div class="swiper_all">
          <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">

                  <div class="caseItem">
                    <img class="case_pro" src="../assets/images/case_pro1.png" />
                    <div class="case_msg">涿溪防窜货是一款一站式全流程防伪营销系统，基于国家标识的名片码、产品码为顾客复购和营销裂变增加了很多场景，涿溪防窜货，真的可以定义新的营销方式。</div>
                    <div class="case_info">
                      <img src="../assets/images/case_logo1.png" />
                      <div class="case_from">
                        <div class="name">周正</div>
                        <div class="job">潞安娜销售总监</div>
                      </div>
                    </div>
                  </div>

                </div>
                <!---->
                <div class="swiper-slide">

                  <div class="caseItem">
                    <img class="case_pro" src="../assets/images/case_pro3.jpg" />
                    <div class="case_msg">皙肽的每一件产品都赋予了工信部授权的一物一码标识码，帮助企业进行获客以及精细化运营，从而促进业务增长。通过给皙肽产品赋码，标识码扫码率达到了40%，带来了近15%的复购率增长。</div>
                    <div class="case_info">
                      <img src="../assets/images/case_logo3.png" />
                      <div class="case_from">
                        <!-- <div class="name">周正</div> -->
                        <div class="job">中国日用化学工业研究院</div>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="swiper-slide">

                  <div class="caseItem">
                    <img class="case_pro" src="../assets/images/case_pro2.png" />
                    <div class="case_msg">BOSS端管理APP解决了多年来数据无法追溯的问题，涿溪防窜货是一股新势力，未来，他可以领航美业防伪营销数据管理一体化。</div>
                    <div class="case_info">
                      <img src="../assets/images/case_logo2.png" />
                      <div class="case_from">
                        <div class="job">韩冠生物CEO</div>
                      </div>
                    </div>
                  </div>

                </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="talkWrap">
      <span class="my_white_btn" @click="openFormMoadl">立即体验</span>
      <span class="my_white_btn" @click="openFormMoadl">联系销售部</span>
    </div>
    <div class="contactWrap">
      <div class="contactInner">
        <van-collapse v-model="activeNames">
            <!-- <van-collapse-item name="1">
              <template #title>
                <div>导航</div>
              </template>
              <ul class="my_links">
                <li><a href="#">产品</a></li>
                <li><a href="#">解决方案</a></li>
                <li><a href="#">行业趋势</a></li>
                <li><a href="#">客户案例</a></li>
                <li><a href="#">认识我们</a></li>
              </ul>
            </van-collapse-item> -->
            <van-collapse-item title="热门链接" name="2">
              <ul class="my_links">
                <li><a href="https://www.citln.cn/">国家顶级节点服务平台</a></li>
                <li><a href="http://www.caict.ac.cn/">中国信通院</a></li>
                <li><a href="https://www.miit.gov.cn/">工业和信息化部</a></li>
              </ul>
            </van-collapse-item>
            <van-collapse-item title="联系我们" name="3">
              <ul class="my_links">
                <li>Tel：13048079186</li>
                <li>公司地址：广州市花都区新华街凤华路2-2</li>
              </ul>
            </van-collapse-item>
        </van-collapse>
      </div>
      <div class="contactBottom">
        <div class="contactList">
            <a href="#" @click="openWxWrap"><img src="../assets/images/wx3.png" /></a>
            <a href="https://weibo.com/u/7673015102"><img src="../assets/images/wb3.png" /></a>
        </div>
        <div class="footer">版权所有 © 涿溪（广州）日化科技发展有限公司<br /> 晋ICP备20004698号-2</div>
      </div>
    </div>

    <!--表单-->
    <div class="myFormWrap" v-show="formVisible">
      <div class="myForm_inner">
        <div class="formTop">申请体验</div>
        <img class="closeFormIcon" src="../assets/images/close.png" @click="closeFormMadal" />
        <van-form validate-first ref="ruleForm">
            <div class="formLabel"><span class="red">*</span>您的名字</div>
            <van-field
                v-model="ruleForm.name"
                autocomplete="off"
                name="name"
                placeholder="希望我们如何称呼您"
                :rules="[
                    {
                        required: true,
                        trigger:'onBlur',
                        message: '名字不能为空'
                    },
                ]"
            />
            <div class="formLabel"><span class="red">*</span>手机/电话</div>
            <van-field
                v-model="ruleForm.phone"
                name="phone"
                placeholder="顾问将于1-2个工作日内致电"
                autocomplete="off"
                :rules="[
                    {
                        required: true,
                        trigger:'onBlur',
                        message: '手机/电话不能为空'
                    },
                ]"
            />
            <div class="formLabel"><span class="red">*</span>企业名称</div>
            <van-field
                v-model="ruleForm.company"
                name="company"
                placeholder="请提供完整的工商注册名称"
                autocomplete="off"
                :rules="[
                    {
                        required: true,
                        trigger:'onBlur',
                        message: '企业名称不能为空'
                    },
                ]"
            />
            <div class="btns btns2">
              <button class="my_btn" @click="submitForm">提交申请</button>
            </div>
        </van-form>
      </div>
    </div>

    <!--微信分享-->
     <div class="wxWrap" v-show="wxVisible" @click="closeWxWrap">
       <div class="wxInner" @click.stop="">
         <img src="../assets/images/mobile_wx.png" />
         <!-- <div class="wx_tip">长按分享图片</div> -->
       </div>
     </div>
    <!-- <div class="title">涿溪防窜货官网</div> -->
    <!-- <div class="box">
      <vue-drawer-layout :drawer-width="230" ref="drawerLayout" @mask-click="closeMenu()">
        <div class="drawer" slot="drawer">
          <div>菜单栏</div>
        </div>
        <div class="content" slot="content">
          <button type="primary" @click="openMenu()">打开菜单栏</button>
        </div>
      </vue-drawer-layout>
    </div> -->

    <!-- <div>折叠面板</div> -->
    <!-- <van-collapse v-model="activeNames">
      <van-collapse-item name="1">
        <template #title>
          <div>标题1 <van-icon name="question-o" /></div>
        </template>
        内容
      </van-collapse-item>
      <van-collapse-item title="标题2" name="2" icon="shop-o">
        内容
      </van-collapse-item>
  </van-collapse> -->

  <!-- <div>轮播图</div> -->

  <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
    <van-swipe-item>1</van-swipe-item>
    <van-swipe-item>2</van-swipe-item>
    <van-swipe-item>3</van-swipe-item>
    <van-swipe-item>4</van-swipe-item>
  </van-swipe> -->

  <!-- <div>视频</div>
  <video-player  class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
  ></video-player> -->
  <div class="notifyBox" v-show="notifyBoxVisible">
    <span>感谢您的反馈</span>
  </div>
  </div>
</template>

<script>
import '@/utils/rem.js'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

import Swiper from 'swiper/dist/js/swiper.js'
import 'swiper/dist/css/swiper.min.css'
const axios = require('axios')

export default {
  data() {
    return {
      formVisible: false,
      wxVisible: false,
      ruleForm: {
        name: '',
        phone: '',
        company: ''
      },
      notifyBoxVisible: false,
      menuState: 'dafault',
      aniClass: '',
      h:0,
      // MenuOpenClass: false,
      // MenuCloseClass: false,

      activeNames:['1'],
      playerOptions : {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: 'https://mzmpic.oss-cn-beijing.aliyuncs.com/mzmvideo.mp4',  // 路径
          type: 'video/mp4'  // 类型
        }],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
    }
    }
  },
  components: {
    // videoPlayer
  },
  methods: {
    // openMenu() {
    //   this.$refs.drawerLayout.toggle();
    // },
    // closeMenu() {
    //   this.$refs.drawerLayout.toggle(false);
    // },
    openMenu() {

      this.h = 0
      this.menuState = 'open'
      this.aniClass = 'animateOpen'
    },
    closeMenu() {
      this.h = 3
      this.menuState = 'dafault'
      this.aniClass = 'animateClose'
    },
    submitForm() {
      let that = this

      // that.closeFormMadal()
      // 校验
      this.$refs.ruleForm.validate().then(() => {
          // this.$toast.success('提交成功')
          that.fetchForm()
      }).catch(() => {
          // this.$toast.fail('提交失败')
      })
    },
    openFormMoadl(){
      this.formVisible=true
    },
    closeFormMadal() {
      this.formVisible=false
      this.ruleForm={
        name: '',
        phone: '',
        company: ''
      }
      this.$refs.ruleForm.resetValidation()
    },
    openWxWrap(){
      this.wxVisible = true
    },
    closeWxWrap() {
      this.wxVisible = false
    },
    fetchForm() {
      let that = this
      let data = new FormData()
          data.append('name', this.ruleForm.name)
          data.append('phone', this.ruleForm.phone)
          data.append('company', this.ruleForm.company)
          axios.post('/cms/home/apply.json', data)
            .then(function (response) {
              that.closeFormMadal()
            })
           that.closeFormMadal()
           that.notifyBoxVisible = true
           setTimeout(function(){
            that.notifyBoxVisible = false
           }, 2000)
    }
  },
  mounted() {
      new Swiper(".swiper-container", {
          loop: true, // 循环模式选项
          loopedSlides: 3, // 必设不然最后一张右边没元素
          //自动播放
          // autoplay:{
          //     delay:2000,
          //     disableOnInteraction:false
          // },
          autoplay: false,
      });

  }
}
</script>
<style scoped>
.drawer {
  width: 100%;
  height: 100%;
  background: #fff;
}
/**轮播图swiper**/
.swiper_all{
  overflow: hidden;

}
.swiper_all .swiper-container {
  overflow: visible!important;
  width: 80%;
  height: 4.1rem;
  /* height: 414px; */
}
.swiper_all .swiper-container .swiper-wrapper .swiper-slide{
  border-radius: 10px;
  /* background: red; */
}
.swiper_all .swiper-container .swiper-wrapper .swiper-slide-active{
  margin-right: 10px;margin-left: 10px;
}
.swiper_all .swiper-container .swiper-wrapper .swiper-slide-prev{
  margin: 0 0 0 -10px;/*由于swiper-slide-active左右设置了10像素，默认往右边挤过去了单独给前一个div设置负10像素左右才能对齐*/
}
/**轮播图**/
.my-swipe .van-swipe-item {
  border: 1px solid #000;
}

/**strat**/
html,body {
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: relative;
}
.container{
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  padding-top: 0.6rem;
}
.topMenu{
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 0.59rem;
  border-bottom: 1px solid #EAE3E3;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0.17rem 0 0.24rem;
  z-index: 8;
}
.topMenu .logo{
  height: .3rem;
}
.topMenu .menu_icon{
  height: .2rem;
}
.subMenu{
  background-color: #fff;
  /* border: 1px solid #000; */
  position: fixed;
  top: 0.59rem;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 8;
}
.subMenu li {
  font-size: 0.15rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #36444D;
  line-height: 0.2rem;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 0.17rem 0 0.24rem;
  margin-top: 0.26rem;
  margin-bottom: 0.07rem;
}
.subMenu li img {
  height: 0.14rem;
}

.animateOpen{
  animation: slideDown 0.5s ease-in-out 0s 1 alternate forwards;
}
.animateClose{
  animation: slideUp 0.5s ease-in-out 0s 1 alternate forwards;
}
@keyframes slideDown {
  form{
    height: 0;
  }
  to {
    height: 3rem;
  }
}
@keyframes slideUp {
  form{
    height: 3rem;
  }
  to {
    height: 0;
  }
}

.homeWrap > img{
  width: 100%;
  display: block;
  /* height: 330px; */
  /* border: 1px solid #f00; */
}
.title{
  font-size: 0.26rem;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #36444D;
  line-height: 0.35rem;
  text-align: center;
  /* margin-bottom: 0.1rem; */
}
.content {
  font-size: 0.13rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #707885;
  line-height: 0.2rem;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
}
.my_btn{
  font-size: 0.16rem;
  /* font-family: PingFang-SC-Medium, PingFang-SC; */
  font-weight: 500;
  color: #FFFFFF;
  line-height: 0.22rem;
  padding: 0.12rem 0.44rem;
  background: linear-gradient(270deg, #F27BCD 0%, #6547DA 100%);
  box-shadow: 0 0.02rem 0.08rem 0 #C5BAE8;
  border-radius: 0.26rem;
  border: none;
  outline: none;
  margin: 0;
  display: inline-block;
}
.btns{
  text-align: center;
  padding: 0;
  margin: 0;
  /* border: 1px solid #000; */
  font-size: 0.16rem;
  padding-top: 0.10rem;
}
.btns2{
  padding-top: 0.3rem;
}
.homeWrap .title{
  margin-bottom: 0.1rem;
}
.whatWrap .title{
  margin-top: 0.48rem;
  margin-bottom: 0.1rem;
}
.whatWrap .content{
  margin-bottom: 0.23rem;
}
.placeWrap .title{
  margin-top: 0.6rem;
}
.placeWrap .content {
  margin-bottom: 0.25rem;
}
.guideWrap .title{
  margin: 0.4rem 0 0;
}
.improveWrap .title{
  padding-top: 0.27rem;
  padding-bottom: 0.65rem;
  width: 80%;
  margin: 0 auto;
}
.caseWrap .title{
  margin-bottom: 0.42rem;
}

/*设置播放按钮的形状与位置*/
.video-player{
  width: 92%;
  margin: 0 auto;
}
.whatWrap /deep/ .vjs-big-play-button{
    font-size: 3em;
    line-height: 1.5em;
    height: 1.7em;
    width: 1.9em;
    top: 70px;
    left: 50%;
    border-radius: 50%;
    transform: translateX(-50%);
}

.placeList .placeItem {
  /* border: 1px solid #f00; */
  width: 92%;
  height: 0.78rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-left: 0.2rem;
  margin: 0.05rem auto;
  background-size: 100% 100%;
}
.placeList .placeItem:nth-child(1) {
  background: url('../assets/images/bj_1.png') top center no-repeat;
}
.placeList .placeItem:nth-child(2) {
  background: url('../assets/images/bj_2.png') top center no-repeat;
}
.placeList .placeItem:nth-child(3) {
  background: url('../assets/images/bj_3.png') top center no-repeat;
}
.placeList .placeItem:nth-child(4) {
  background: url('../assets/images/bj_4.png') top center no-repeat;
}
.placeList .placeItem:nth-child(5) {
  background: url('../assets/images/bj_5.png') top center no-repeat;
}
.placeList .placeItem > img {
  width: 0.42rem;
  height: 0.42rem;
  margin-right: 0.15rem;
}
.placeList .place_info{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.place_info .tit{
  font-size: 0.15rem;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  color: #212B34;
}
.place_info .text{
  font-size: 0.12rem;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: #212B34;
}

.guideBlock{
  padding: 0.45rem 0.2rem 0.2rem;
  /* border: 1px solid #f00; */
}
.guideBlock.grey{
  background-color: #F5F5F8;
}

.guideBlock .guideTop {
  font-size: 0.16rem;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #36444D;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.guideBlock .guideTop .link {
  font-size: 0.13rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #714BD9;
}

.guideBlock .guideText{
  font-size: 0.13rem;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: #707885;
  text-align: left;
  margin-top: 0.13rem;
  margin-bottom: 0.28rem;
}
.guideBlock .guide_img{
  display: block;
  margin: 0 auto;
  width: 90%;
}
.improveWrap.change{
  background: linear-gradient(180deg, #F5F5F8 0%, #FFFFFF 100%);
}
.improveWrap .ywym_img{
  display: block;
  margin: 0 auto;
  width: 90%;
}
.improveWrap .ywym_tit{
  font-size: 0.16rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #1F2329;
  margin: 0 auto;
  text-align: center;
  margin-top: 0.28rem;
  margin-bottom: 0.5rem;
}
.improveWrap .sj_img{
  display: block;
  margin: 0 auto;
  width: 90%;
}
.improveWrap .sj_tit{
  font-size: 0.16rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #1F2329;
  width: 70%;
  margin: 0 auto;
  /* border: 1px solid #f00; */
  text-align: center;
  margin-top: 0.33rem;
  margin-bottom: 0.5rem;
}
.caseWrap{
  background: linear-gradient(180deg, #FFFFFF 0%, #F7F6FA 100%);
  padding-bottom: 0.6rem;
}
.caseItem{
  width: 2.90rem;
  height: 4.05rem;
  box-shadow: 0px 2px 9px 0px #EDEDED;
  border-radius: 8px;
  background-color: #fff;
  overflow: hidden;
}

.caseItem .case_pro{
  width: 100%;
  height: 1.48rem;
}
.caseItem .case_msg{
  font-size: 0.14rem;
  /* font-family: FZQKBYSJW--GB1-0, FZQKBYSJW--GB1; */
  font-weight: normal;
  color: #3C424C;
  line-height: 0.28rem;
  padding: 0.2rem 0.1rem 0.17rem 0.1rem;
  box-sizing: border-box;
  height: 1.7rem;
  overflow: hidden;
}
.caseItem .case_info{
  padding: 0 0.1rem 0.16rem 0.1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.case_info > img {
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.06rem;
}
.case_info .case_from{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  height: 0.6rem;
  overflow: hidden;
  /* border: 1px solid #f00; */
  font-size: 0.16rem;
}
.case_info .case_from .name {
  font-size: 0.16rem;
  height: 0.2rem;;
  /* font-family: PingFang-SC-Medium, PingFang-SC; */
  font-weight: 500;
  color: #3C424C;
}
.case_info .case_from .job{
  font-size: 0.13rem;
  /* font-family: PingFang-SC-Medium, PingFang-SC; */
  font-weight: 500;
  color: #767D8A;
}
.talkWrap{
  width: 100%;
  height: 1.8rem;
  background: url('../assets/images/talk_bg.png') top center no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding-top: 1.05rem;
}
.talkWrap .my_white_btn{
  font-size: 0.16rem;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  color: #6D44E9;
  display: inline-block;
  width: 1.2rem;
  height: 0.32rem;
  line-height: 0.32rem;
  background-color: #fff;
  text-align: center;
  /* margin: 1.05rem 0.8rem 0; */
  border-radius: 0.38rem;
  margin: 0 0.08rem;
}
.contactWrap{
  background-color: #F7F6FA;
  padding: 0.27rem 0.2rem 0.15rem 0.2rem;
}
.contactInner{
  border-bottom: 1px solid #EBEAEE;
  padding-bottom: 0.25rem;
}
.contactInner ul.my_links li{
  font-size: 0.13rem;
  font-weight: 400;
  color: #3C424C;
  line-height: 0.18rem;
  padding-bottom: 0.12rem;
}
.contactInner ul.my_links li a {
  color: #3C424C;
}
.contactBottom .contactList {
  display: flex;
  flex-direction: row;
  padding-bottom: 0.24rem;
  padding-top: 0.17rem;
}
.contactBottom .contactList a {
  display: block;
  height: 0.22rem;
  line-height: 0.22rem;
  font-size: 0.22rem;
}
.contactBottom .contactList img {
  width: 0.27rem;
  height: 0.22rem;
  margin-right: 0.16rem;
}
.contactBottom .footer {
  font-size: 0.12rem;
  line-height: 0.17rem;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #6C7480;
  text-align: center;
}
.floatContact{
  position: fixed;
  width: 0.56rem;
  height: 0.56rem;
  background: #FFFFFF;
  box-shadow: 0px 2px 9px 0px #DCD7EA;
  border: 1px solid rgba(109, 59, 150, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
  right: 0.08rem;
  bottom: 2rem;
  z-index: 2;
  border-radius: 50%;
}
.floatContact > img {
  width: 0.23rem;
  height: 0.23rem;
}
.myFormWrap{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: rgba(0,0,0,0.5);
}
.myFormWrap .myForm_inner{
  width: 90%;
  height: 4.62rem;
  box-sizing: border-box;
  padding-top: 0.5rem;
  margin: 1rem auto 0;
  border-radius: 0.18rem;
  position: relative;
  background: #fff url('../assets/images/form_bg.png') bottom right no-repeat;
}
.myForm_inner .closeFormIcon {
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
  opacity: 0.5;
}
.myForm_inner .formLabel{
  font-size: 0.14rem;
  /* font-family: PingFang-SC-Bold, PingFang-SC; */
  /* font-weight: bold; */
  color: #0A0909;
  padding: 0.24rem 0rem 0.14rem 0.16rem;
}
.myForm_inner .formLabel .red {
  color: #CA2325;
}
.myForm_inner /deep/ .van-field__control{
  height: 0.45rem;
  border: 1px solid #D7DCE3;
  border-radius: 0.04rem;
  padding: 0 0.2rem;

}
.myForm_inner .van-cell {
  background-color: transparent;
  padding: 0 0.16rem;
}
.formTop{
  width: 1.86rem;
  height: 0.5rem;
  position: absolute;
  top: -0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.16rem;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #FFFFFF;
  /* border: 1px solid #000; */
  text-align: center;
  padding-top: 0.1rem;
  box-sizing: border-box;
  background: url('../assets/images/form_tit_bg.png') top center no-repeat;
}
/** 微信分享弹窗 **/
.wxWrap{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: rgba(0,0,0,0.5);
}
.wxWrap .wxInner{
  width: 90%;
  box-sizing: border-box;
  margin: 1rem auto 0;
  border-radius: 0.18rem;
  position: relative;
  background: #fff;
  padding: 0.2rem;
}
.wxWrap .wxInner > img {
  width: 100%;
  display: block;
}
.wxWrap .wxInner .wx_tip{
  font-size: 0.12rem;
  text-align: center;
  padding: 0;
  margin: 0;
}
/**改折叠样式**/
.contactInner /deep/ .van-cell__title{
  font-size: 0.16rem;
  font-weight: 500;
  color: #3C424C;
}
.contactInner /deep/ .van-cell{
  background-color: #F7F6FA;
}
.contactInner /deep/ .van-collapse-item__content {
  background-color: #F7F6FA;
}

/**感谢申请**/
.notifyBox {
  position: fixed;
  top: 40%;
  left: 50%;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 0.14rem;
  padding: 0.05rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.05rem;
  width: 2rem;
  margin-left: -1rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/MobileHome.vue